const doc = [["2026-01-25", "2026-01-18", "2025-10-13", "2025-04-02"]];
module.exports = doc.length <= 1 ? doc[0] : doc;